import request, { HttpMethod } from '@app/libs/request';
import { serverUrl } from '@app/config';
import {
  API_VERSION_HEADER,
  SupplierRegistrationProcessRequest,
  WEB_REFERRER_HEADER,
} from '@supplierRegistration/domain/supplierRegistration';
import { buildCaptchaHeaders } from '@supplierRegistration/services/captchaHeaders';
import { SupplierRegistrationAsyncInitiateValidationProcessRequest } from '@supplierRegistration/domain/supplierRegistrationAsyncInitiateValidationProcess';
import { RawAxiosRequestHeaders } from 'axios';

export async function preRegistrationRequest(
  supplierData: SupplierRegistrationProcessRequest,
  captchaToken: string | undefined,
): Promise<void> {
  const headers: RawAxiosRequestHeaders = {
    [WEB_REFERRER_HEADER]: document.referrer,
    [API_VERSION_HEADER]: 'v2',
    ...buildCaptchaHeaders(captchaToken, 'pre-registration'),
  };

  await request<void>(serverUrl, `/api/supplier-validation/pre-registration`, {
    data: supplierData,
    headers,
    method: HttpMethod.post,
    dontRedirectToLogin: true,
    suppressNotification: true,
    errorsHandler: {
      default: {
        message: 'Could not request for supplier validation pre registration.',
      },
    },
  });
}

export async function preRegistrationRequestFromAsyncInitiateValidation(
  supplierData: SupplierRegistrationAsyncInitiateValidationProcessRequest,
  asyncProcessId: string,
  captchaToken: string | undefined,
): Promise<void> {
  const headers: RawAxiosRequestHeaders = {
    [WEB_REFERRER_HEADER]: document.referrer,
    [API_VERSION_HEADER]: 'v2',
    ...buildCaptchaHeaders(captchaToken, 'pre-registration-async'),
  };

  await request<void>(serverUrl, `/api/supplier-validation/pre-registration/async/:asyncProcessId`, {
    data: supplierData,
    pathParams: { asyncProcessId },
    headers,
    method: HttpMethod.post,
    dontRedirectToLogin: true,
    suppressNotification: true,
    errorsHandler: {
      default: {
        message: 'Could not request for supplier validation pre registration async.',
      },
    },
  });
}
